module.exports = __webpack_public_path__ + "img/raw6.4ea88da3.png";